module.exports = __webpack_public_path__ + "img/0Q3B3739_Foamcore.40e0ad14.jpg";